import { combineReducers } from 'redux'

import { reducer as uploadBtsFile } from './uploadBtsFile'
import { reducer as getBtsData } from './getBtsData'

export default combineReducers({
    uploadBtsFile,
    getBtsData,
})
